"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Dropdown_base_1 = require("./Dropdown.base");
var Dropdown_styles_1 = require("./Dropdown.styles");
exports.Dropdown = Utilities_1.styled(Dropdown_base_1.DropdownBase, Dropdown_styles_1.getStyles, undefined, {
    scope: 'Dropdown'
});
//# sourceMappingURL=Dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Dropdown/Dropdown.js
// module id = 975
// module chunks = 0